import React, { useContext } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import ReadytoGetStarted from "./components/ReadytoGetStarted";
import Twocolumn from "./components/Twocolumn";
import Banner from "./components/Banner";
import BannerFullview from "./components/BannerFullview";
import { UserContext } from "../App";

const Landing = () => {
  const { setuserContextState } = useContext(UserContext);

  return (
    <>
      <Header setuserContextState={setuserContextState} />
      <Banner setuserContextState={setuserContextState} />
      <BannerFullview />
      <Twocolumn />
      <ReadytoGetStarted setuserContextState={setuserContextState} />
      <Contact />
      <Footer />
    </>
  );
};

export default Landing;
